import { ICONS } from '../../../../icons';
import Icon from '../../../../icons/Icon';

import scss from './UploadModal.module.scss';

function ImagePreview({ image, onRemove, onError }) {
  const handleRemove = () => {
    onRemove();
  };

  const handleError = () => {
    onError?.();
  };

  if (!image) return null;

  const imageUrl = URL.createObjectURL(image);

  return (
    <div className={scss.imagePreview}>
      <img src={imageUrl} alt='uploaded-image-preview' onError={handleError} />
      <Icon
        icon={ICONS.Cross}
        onClick={handleRemove}
        disableCommonStyles
        disableCommonColors
        className={scss.removeIcon}
      />
    </div>
  );
}

export default ImagePreview;
